import { ChangeEvent, useState } from "react";
import { useFormContext } from "react-hook-form";
import { get } from "lodash";
import classNames from "classnames";
import { FormFieldProps } from "./LInputField";

export const LTextareaField = ({ ...props }: LTextareaFieldProps): JSX.Element => {
    const {
        register,
        formState: { errors }
    } = useFormContext();

    const [fieldValue, setFieldValue] = useState(props.defaultValue ?? "");

    const error = get(errors, props.inputName);
    const hasError = error !== undefined && error !== null;
    const fieldError = error?.message?.toString() ?? "";

    const classes = classNames("textarea", hasError ? "is-danger" : "");
    const labelClasses = classNames(
        "label",
        "is-small",
        hasError ? "is-danger" : "",
        props.theme === "dark" ? "has-text-white" : ""
    );

    const handleOnInput = (e: ChangeEvent<HTMLTextAreaElement>): void => {
        setFieldValue(e.target.value);
    };

    const getCounter = (): string => {
        return `${fieldValue.length}/${props.maxLength!}`;
    };

    return (
        <div className="field">
            <label className={labelClasses}>{props.label}</label>
            <div className="control">
                <textarea
                    className={classes}
                    placeholder={props.placeholder}
                    value={fieldValue}
                    maxLength={props.maxLength}
                    onInput={handleOnInput}
                    {...register(props.inputName, { onChange: props.onChange })}
                />
            </div>
            <div className="is-flex is-justify-content-space-between">
                {hasError && <p className="help is-danger">{fieldError}</p>}
                {!hasError && <p>{props.footer}</p>}
                <div></div>
                {props.counter && <p className="has-text-grey-light mr-2">{getCounter()}</p>}
            </div>
        </div>
    );
};

export interface LTextareaFieldProps extends FormFieldProps {
    placeholder?: string;
    rows?: number;
    counter?: boolean;
    theme?: "dark" | "light";
    footer?: string;
}
